import type { ColorScheme } from '@/lib/colorSchemes';
import { COLOR_SCHEMES } from '@/lib/colorSchemes';

/**
 * Segment layout mode for multi-segment hands
 */
export type SegmentLayout = 'bookcase' | 'stacked';

/**
 * Chart configuration for visual settings
 */
export interface ChartConfiguration {
  // Bar dimensions
  barSize: number;
  gap: number;
  maxHeight: number;

  // Color scheme
  colorScheme: ColorScheme;

  // Height scale
  useLogScale: boolean;

  // Display options
  showValues: boolean;
  showLegend: boolean;

  // Multi-segment layout
  segmentLayout: SegmentLayout;
  segmentGap: number;

  // Label colors
  invertLabelColors: boolean;
}

/**
 * Default chart configuration
 */
export const DEFAULT_CHART_CONFIG: ChartConfiguration = {
  barSize: 0.5,
  gap: 0.05,
  maxHeight: 4,
  colorScheme: COLOR_SCHEMES.HEATMAP_BLUE_RED,
  useLogScale: false,
  showValues: false,
  showLegend: false,
  segmentLayout: 'bookcase',
  segmentGap: 0,
  invertLabelColors: false,
};
